import { apeChain } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createApeChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}): Chain =>
  createApeChainCustom({
    client: createClient({ chain: apeChain, httpRpcs: apeHttpRpcs }),
    // Etherscan V2 の対応 chain から外れたため、Caldera の Blockscout を使う。
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'ApeChain Explorer',
      baseUrl: 'https://apechain.calderaexplorer.xyz',
      apiBaseUrl: 'https://apechain.calderaexplorer.xyz/api',
      proxyUrl,
    }),
  })

type CreateApeChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createApeChainCustom = ({
  client,
  explorer,
}: CreateApeChainCustomParameters): Chain => ({
  id: 33139,
  network: 'apechain',
  name: 'ApeChain',
  nativeToken: {
    name: 'ApeCoin',
    symbol: 'APE',
    decimals: 18,
    currency: {
      symbol: 'APE',
      type: 'CryptoCurrency',
      id: 'apecoin',
      name: 'ApeCoin',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x48b62137edfa95a428d35c09e44256a739f6b557',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'apechain',
  defillamaId: undefined,
})

export const apeHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.apechain.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://apechain.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const apeWebsocketRpcUrls: string[] = [
  'wss://rpc.apechain.com/ws',
  'wss://apechain.drpc.org',
]
